import { useEffect, useState } from 'react';
import { Link, useLocation } from '@tanstack/react-router';
import { useServerFn } from '@tanstack/react-start';
import { useQuery } from '@tanstack/react-query';

import type { BlogPost } from '@/lib/blog';
import { getPostsServer } from '@/lib/blog.server';
import { ToggleTheme } from '@common/toggle-theme';
import { SearchBar } from './searchbar';
import { Button } from '../ui/button';

const NavBar = () => {
  const getPosts = useServerFn(getPostsServer);

  const { data: posts } = useQuery({
    queryKey: ['posts'],
    queryFn: () => getPosts(),
  });

  const [post, setPost] = useState<BlogPost | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (!posts) return;
    const slug = location.pathname.split('/')[2];
    const foundPost = posts.find((p) => p.slug === slug);
    setPost(foundPost || null);
  }, [posts, location.pathname]);

  return (
    <nav className="mx-auto mb-4 w-full flex justify-between items-center bg-accent/50 shadow-sm shadow-foreground/10 backdrop-blur-md py-3 px-8 font-bold gap-5 z-40">
      <div className="flex items-center justify-between w-full gap-x-3 text-foreground/80 max-w-full overflow-hidden">
        <Link to="/" className="hover:underline decoration-red-500">
          <span className="text-foreground grow">{"ley0x@blog$"}</span>
        </Link>
        <div className="shrink flex items-center w-full gap-2">
          <Link to="/" className="hover:underline decoration-red-500">
            Home
          </Link>
          {!!post && (
            <>
              <span className='hidden lg:block'>/</span>
              <span
                className="hidden line-clamp-1 lg:flex hover:underline decoration-red-500"
              >
                {post.title}
              </span>
            </>
          )}
          <div className="h-4 w-2 self-center bg-red-500 animate-pulse" />
        </div>
      </div>
      <div className="flex grow gap-x-2 items-center">
        <Button variant="ghost" size="default" className="px-0 py-0 cursor-pointer">
          <Link to="/techwatch" className="px-2 h-full w-full flex items-center">
            📣 Tech watch
          </Link>
        </Button>
        <Button variant="ghost" size="default" className="px-0 py-0 cursor-pointer">
          <Link to="/memes" className="px-2 h-full w-full flex items-center">
            🖼 Memes
          </Link>
        </Button>
        <SearchBar posts={posts || []} />
        <ToggleTheme />
      </div>
    </nav>
  );
};

export default NavBar;
